<mat-card class="w-full shadow-lg rounded-xl overflow-hidden">
  <mat-card-header class="py-4! mb-4! bg-primary-container">
    <mat-card-title class="text-2xl! font-bold">HLSS</mat-card-title>
    <mat-card-subtitle class="text-inherit! opacity-80 mt-2! text-xs!">
      サインインして続行
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="px-6 py-4">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>メールアドレス</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="username" required>
        @if (form.controls.email.hasError('required')) {
          <mat-error>メールアドレスは必須です</mat-error>
        }
        @if (form.controls.email.hasError('email')) {
          <mat-error>有効なメールアドレスを入力してください</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>パスワード</mat-label>
        <input matInput [type]="hidePassword() ? 'password' : 'text'" formControlName="password" autocomplete="current-password" required>
        <button matIconButton matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="hidePassword() ? 'パスワードを表示' : 'パスワードを隠す'" [attr.aria-pressed]="!hidePassword()">
          <mat-icon>{{hidePassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        @if (form.controls.password.hasError('required')) {
          <mat-error>パスワードは必須です</mat-error>
        }
        @if (form.controls.password.hasError('minlength')) {
          <mat-error>パスワードは6文字以上で入力してください</mat-error>
        }
      </mat-form-field>

      <button matButton="tonal" type="submit" class="px-6! py-6! mt-2! text-base! self-center" [disabled]="form.invalid || isLoading()">
        {{ isLoading() ? 'サインイン中...' : 'サインイン' }}
      </button>
    </form>
  </mat-card-content>
</mat-card>
